class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.itemsCart = this.querySelector('cart-items') || this.querySelector('cart-drawer-items');
    this._processingFreeGift = false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });

    const cartLinkTwo = document.querySelector('#cart-icon-bubble-two');
    cartLinkTwo?.setAttribute('role', 'button');
    cartLinkTwo?.setAttribute('aria-haspopup', 'dialog');
    cartLinkTwo?.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLinkTwo);
    });
    cartLinkTwo?.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLinkTwo);
      }
    });

    const cartLinkThree = document.querySelector('.icon-cart');
    cartLinkThree?.setAttribute('role', 'button');
    cartLinkThree?.setAttribute('aria-haspopup', 'dialog');
    cartLinkThree?.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLinkThree);
    });
    cartLinkThree?.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLinkThree);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.contains('is-empty') &&
      this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

      this.open();
    });

    this.validateCart(parsedState);
  }

  async getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      return cartData;
    } catch (error) {
      throw new Error('Error fetching cart data: ' + error.message);
    }
  }

  async addToCartOnly(data, idVariant) {
    try {
      let request = await fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
      });

      if (!request.ok) return publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form',
        productVariantId: idVariant,
        errors: request.errors || request.description,
        message: request.message,
      });

      let response = await request.json();

      return response;
    } catch (error) {

    }
  }

  validateCart(response) {
    const parser = new DOMParser();
    const cartDrawerHTML = response.sections['cart-drawer'];
    const doc = parser.parseFromString(cartDrawerHTML, 'text/html');

    const footer = doc.querySelector('.cart-drawer__footer');
    const rawTotal = footer ? footer.dataset.total || '0' : '0';
    const priceTotal = Number(rawTotal) || 0;

    if (priceTotal >= 99) {
      $('.title-free').text('Free Shipping');
      $('.title-free').addClass('active');
    } else {
      $('.title-free').text('Cart');
      $('.title-free').removeClass('active');
    }

    setTimeout(() => {
      $('#cart-icon-bubble-two .cart-count-bubble span').text($('#cart-icon-bubble .cart-count-bubble span').first().text());
      if ($('.btn-continue')) {
        $('.btn-continue').removeClass('custom-loader');
      }

      const sliderUpsell = document.querySelector('.content-slider-upsell');
      if (sliderUpsell) {
        new Swiper(sliderUpsell, {
          loop: true,
          slidesPerView: 2,
          spaceBetween: 12,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    }, 1000);

    // this.handleFreeGift();
  }

  async handleFreeGift() {
    if (this._processingFreeGift) return;
    this._processingFreeGift = true;

    const idVariant = 44683287953599;
    const threshold = 150;

    try {
      const cart = await this.getCartData();
      const subtotalCents = typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : (typeof cart.total_price === 'number' ? cart.total_price : 0);
      const subtotal = subtotalCents / 100;

      const freeLines = (cart.items || []).filter((item) => {
        if (item.variant_id !== idVariant) return false;
        const props = item.properties || {};
        return props._free_gift === true || props._free_gift === 'true';
      });

      if (subtotal >= threshold) {
        if (freeLines.length === 1 && freeLines[0].quantity === 1) {
          return;
        }

        if (freeLines.length === 0) {
          await this.validateExistItem(idVariant);
          return;
        }

        const sections = this.getSectionsToRender().map((section) => section.id);
        const [first, ...rest] = freeLines;

        if (first.quantity !== 1) {
          await this.changeLineQuantity(first.key, 1, sections);
        }

        for (const line of rest) {
          await this.changeLineQuantity(line.key, 0, sections);
        }

        return;
      }

      if (!freeLines.length) return;

      const sections = this.getSectionsToRender().map((section) => section.id);
      for (const line of freeLines) {
        await this.changeLineQuantity(line.key, 0, sections);
      }
    } catch (e) {
      console.error('Error in handleFreeGift:', e);
    } finally {
      this._processingFreeGift = false;
    }
  }

  async changeLineQuantity(lineKey, quantity, sections) {
    const body = {
      id: lineKey,
      quantity,
      sections,
    };

    let request = await fetch('/cart/change.js', {
      body: JSON.stringify(body),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      method: 'POST'
    });

    if (!request.ok) {
      return publish(PUB_SUB_EVENTS.cartError, {
        source: 'cart-drawer',
        productVariantId: null,
        errors: request.errors || request.description,
        message: request.message,
      });
    }

    let response = await request.json();
    this.renderContents(response);
  }

  async validateExistItem(idVariant) {
    const requestBody = {
      items: [
        {
          id: idVariant,
          quantity: 1,
          properties: {
            _free_gift: true
          }
        }
      ],
      sections: this.getSectionsToRender().map((section) => section.id),
    };

    this.sendCart(requestBody, idVariant);
  }

  async sendCart(formData, idVariant) {
    let request = await fetch('/cart/add.js', {
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      method: 'POST'
    });

    if (!request.ok) return publish(PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: idVariant,
      errors: request.errors || request.description,
      message: request.message,
    });

    let response = await request.json();

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: idVariant, cartData: response });

    this.renderContents(response);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
